import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchLearningTrustScore = createAsyncThunk("fetchLearningTrustScore", async ({ page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 20,
        distributorCode: filters?.distributorCode || "",
        skuForecastBias: filters?.skuForecastBias || "",
        trustScoreMin: filters?.trustScoreMin || "",
        trustScoreMax: filters?.trustScoreMax || "",
    });

    const response = await axiosHttp.get(`replenishment/learning?${params}`);
    return response.data;
});

const LearningTrustScoreSlice = createSlice({
    name: "LearningTrustScoreSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 20,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchLearningTrustScore.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchLearningTrustScore.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 20)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchLearningTrustScore.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default LearningTrustScoreSlice.reducer;
